export default {
  title: "Olá",
};
